import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";

type MacroAssetAllocationContentProps = {
  configData: ConstraintConfigType;
};

export function MacroAssetAllocationContent({ configData }: MacroAssetAllocationContentProps) {
  return (
    <ConstraintContent
      configData={configData}
      dataKey="macro_asset_allocation"
    />
  );
}
